import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useNavigate } from "react-router-dom";
import { createArrangement } from '../store/knownArrangementsSlice';
import TextareaAutosize from 'react-textarea-autosize';
import { DataContainer } from '../components/DataContainer';
import DriverSelect from '../components/DriverSelect';
import TimeInput from '../components/TimeInput';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import DurationInput from '../components/DurationInput';





function Arrangement(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // ##### Form state #####

    const driverSelectRef = useRef(null);
    const [ description, setDescription ] = useState("");
    const [ name, setName ] = useState("");
    const [ depart, setDepart ] = useState("00:00");
    const [ duration, setDuration ] = useState("00:00");
    const [ days, setDays ] = useState([ false, false, false, true, false, false, false ]);
    const [ startDate, setStartDate ] = useState("");
    const [ endDate, setEndDate ] = useState("");

    async function onCreate() {
        console.log("duration:", duration);

        const newId = await unwrapResult(await dispatch(createArrangement({
            name: name,
            description: description,
            driver: driverSelectRef.current.value,
            on_monday: days[0],
            on_tuesday: days[1],
            on_wednesday: days[2],
            on_thursday: days[3],
            on_friday: days[4],
            on_saturday: days[5],
            on_sunday: days[6],
            start: startDate,
            end: endDate,
            depart,
            duration,
        })));

        toast.success("Regulaarvedu loodud!");
        navigate('/platform/arrangement/' + newId);
    }





    return (
        <div className="column p32 screen center-cross">
            <div className="column g32" style={{ width: '100%', maxWidth: 800 }}>
                <h1>Uus regulaarvedu</h1>

                <DataContainer actionType={'knownArrangements/updateArrangement'}>
                    <div className="line g32 w100">

                        <div className="column g16 grow">
                            <div className="column g4">
                                <b>Kirjeldus</b>
                                <TextareaAutosize spellCheck={false} minRows="3" style={{ resize: 'none', fontFamily: 'unset' }} placeholder='Täpsusta kui vaja' value={description} onChange={(e) => setDescription(e.target.value)} />
                            </div>

                            <div className="column g4">
                                <div className="column">
                                    <b>Algus</b>
                                    <p>Esimene päev, millal see vedu toimub. Võib märkida ka selle esimese nädala esmaspäeva.</p>
                                </div>
                                <input type="date" value={startDate} onChange={(e) => console.log("start:", e.target.value) || setStartDate(e.target.value)} />
                            </div>

                            <div className="column g4">
                                <div className="column">
                                    <b>Lõpp</b>
                                    <p>Viimane päev, millal see vedu toimub. Võib märkida ka selle viimase nädala pühapäeva.</p>
                                </div>
                                <input type="date" value={endDate} onChange={(e) => console.log("end:", e.target.value) || setEndDate(e.target.value)} />
                            </div>
                        </div>

                        <div className="column g16 grow">

                            <div className="column g4">
                                <b>Nimi</b>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                            </div>

                            <div className="column g4">
                                <b>Juht</b>
                                <DriverSelect innerRef={driverSelectRef} />
                            </div>

                            <div className="column g4">
                                <b>Väljumine</b>
                                <TimeInput value={depart} onChange={setDepart} useColon={true} />
                            </div>

                            <div className="column g4">
                                <b>Tööaeg (kestus)</b>
                                <TimeInput value={duration} onChange={setDuration} />
                            </div>

                            <div className="column g4">
                                <b>Päevad</b>
                                <div className="line g8">
                                    <button style={days[0] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                            onClick={() => setDays(days => { const nd = [...days]; nd[0] = !days[0]; return nd; })} >
                                        E
                                    </button>
                                    <button style={days[1] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                            onClick={() => setDays(days => { const nd = [...days]; nd[1] = !days[1]; return nd; })} >
                                        T
                                    </button>
                                    <button style={days[2] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                            onClick={() => setDays(days => { const nd = [...days]; nd[2] = !days[2]; return nd; })} >
                                        K
                                    </button>
                                    <button style={days[3] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                            onClick={() => setDays(days => { const nd = [...days]; nd[3] = !days[3]; return nd; })} >
                                        N
                                    </button>
                                    <button style={days[4] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                            onClick={() => setDays(days => { const nd = [...days]; nd[4] = !days[4]; return nd; })} >
                                        R
                                    </button>
                                    <button style={days[5] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                            onClick={() => setDays(days => { const nd = [...days]; nd[5] = !days[5]; return nd; })} >
                                        L
                                    </button>
                                    <button style={days[6] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                            onClick={() => setDays(days => { const nd = [...days]; nd[6] = !days[6]; return nd; })} >
                                        P
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </DataContainer>

                <div className="hr"></div>

                <div className="row" style={{ justifyContent: 'end' }}>
                    <button onClick={onCreate}>Salvesta</button>
                </div>

            </div>
        </div>
    );
};

export default Arrangement;